import * as React from 'react';
import { Box, createStyles, makeStyles, Typography, Divider, useMediaQuery } from '@material-ui/core';
import { TranquiTheme } from '../../containers/App/theme';
import RenderText from '../../dictionaries/RenderText';
import { getImageUrl } from '../../utils/imagesRoot';
import useDictionary from '../../dictionaries/context/useDictionary';
import { getBrandBoolean } from '../../utils/getBrandBoolean';

const useStyles = makeStyles((theme: TranquiTheme) => createStyles({
  box: {
    background: theme.palette.bg2.default,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 0,
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      flexDirection: 'column',
    },
    '& a': {
      textDecoration: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    '& a *': {
      fontWeight: theme.typography.fontWeightBold,
    },
  },
  text: {
    ...theme.typography.small as any,
    color: theme.palette.text3.main,
    [theme.breakpoints.down('sm')]: {
      ...theme.typography.xsmall,
      color: theme.palette.text3.main,
    },
  },
  divider: {
    height: '60%',
    margin: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  securityFooter: {
    display: 'flex',
    padding: theme.spacing(2, 0),
    alignItems: 'center',
    justifyContent: 'space-evenly',
  },
}));

type BrandInfoItem = { text: string, link?: string };

const YEAR = new Date().getFullYear();

const BRAND_CONTACT: BrandInfoItem[] = [
  { text: 'footer_brand' },
  { text: 'footer_brand_email' },
];
const BRAND_POLICY: BrandInfoItem[] = [
  {
    text: 'footer_terms_and_conditions',
    link: 'footer_terms_and_conditions_link',
  },
  {
    text: 'footer_personal_data',
    link: 'footer_personal_data_link',
  },
];

const { isBrandTranqui } = getBrandBoolean();
const footerText: BrandInfoItem[] = [
  ...BRAND_CONTACT,
  ...(isBrandTranqui ? BRAND_POLICY : []),
];

const Footer: React.FC<{ isIdValidation?: boolean }> = ({ isIdValidation }) => {
  const classes = useStyles();
  const isWeb = useMediaQuery((theme: TranquiTheme) => theme.breakpoints.up('md'));
  const { gT } = useDictionary();

  if (isIdValidation) {
    return (
      <Box className={classes.securityFooter}>
        {isWeb && (
        <Box className="certificationText">
          <RenderText textKey="validation_initial_page_certification_text" isMarkdown />
        </Box>
        )}
        <img src={getImageUrl('SSL1.png')} alt="SSL" height="35px" />
        <img src={getImageUrl('AWS.png')} alt="AWS" />
        <img src={getImageUrl('Politics.png')} alt="Politics" height="35px" />
      </Box>
    );
  }

  return (
    <Box className={classes.box} component="footer">
      {
        footerText.map(({ text, link }, index) => {
          const content = (
            <Typography className={classes.text}>
              {gT(text, { year: YEAR })}
            </Typography>
          );
          return (
            <React.Fragment key={text}>
              {index !== 0 && <Divider orientation="vertical" className={classes.divider} />}
              {link ? <a href={gT(`${text}_link`)} target="_blank" rel="noreferrer">{content}</a> : content}
            </React.Fragment>
          );
        })
      }
    </Box>
  );
};

export default Footer;
